var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 12.6666C12.6667 13.0346 12.368 13.3333 12 13.3333H4C3.63267 13.3333 3.33333 13.0346 3.33333 12.6666V3.33325C3.33333 2.97689 3.62508 2.66659 4 2.66659H12C12.368 2.66659 12.6667 2.96592 12.6667 3.33325V12.6666ZM4 1.33325C2.83927 1.33325 2 2.05607 2 3.33325V12.6666C2 13.7693 2.89733 14.6666 4 14.6666H12C13.1027 14.6666 14 13.7693 14 12.6666V3.33325C14 2.23059 13.1027 1.33325 12 1.33325C12 1.33325 5.33333 1.33325 4 1.33325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8574 5.99984H5.14274C4.77474 5.99984 4.47607 5.70117 4.47607 5.33317C4.47607 4.96517 4.77474 4.6665 5.14274 4.6665H10.8574C11.2261 4.6665 11.5241 4.96517 11.5241 5.33317C11.5241 5.70117 11.2261 5.99984 10.8574 5.99984Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8574 8.66659H5.14274C4.77474 8.66659 4.47607 8.36859 4.47607 7.99992C4.47607 7.63125 4.77474 7.33325 5.14274 7.33325H10.8574C11.2261 7.33325 11.5241 7.63125 11.5241 7.99992C11.5241 8.36859 11.2261 8.66659 10.8574 8.66659Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8574 11.3333H5.14274C4.77474 11.3333 4.47607 11.0353 4.47607 10.6667C4.47607 10.298 4.77474 10 5.14274 10H10.8574C11.2261 10 11.5241 10.298 11.5241 10.6667C11.5241 11.0353 11.2261 11.3333 10.8574 11.3333Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimOverview);
export default __webpack_public_path__ + "static/media/claim_overview.40779262cb1d0cd89e4676d370d572ed.svg";
export { ForwardRef as ReactComponent };